export default "__VITE_ASSET__DoQ_Nzy9__"